const LINE_BREAK_REGEX = /\\r\\n|\\n|\\r|\r\n|\r/g;

/**
 * Turns real (`\r\n`, `\r`) and escaped literal (`\\n`, `\\r\\n`, `\\r`)
 * line breaks into plain `\n`, so the text can be displayed with
 * `white-space: pre-wrap`.
 */
export const normalizeLineBreaks = (text?: string | null): string =>
  (text ?? '').replace(LINE_BREAK_REGEX, '\n');
